import React, { useMemo } from 'react';
import { useContentProxyData } from '../hooks/useContentProxyData';
import { ContentProxyTeam } from '../models/contentProxyModel';
import {TeamDataContext} from "./TeamData.context";

export const TeamDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { data: teams } = useContentProxyData<ContentProxyTeam[]>(
        'teams',
        300000, // 5 minute cache
        'incGeneral=true&onlyActive=true'
    );

    const contextValue = useMemo(() => ({
        teams: teams || [],
        getTeamByCountryCode: (code: string) =>
            teams?.find(team => team.code === code)
    }), [teams]);

    return (
        <TeamDataContext.Provider value={contextValue}>
            {children}
        </TeamDataContext.Provider>
    );
};